<template>
	<v-dialog v-model="open" max-width="600" persistent>
		<v-card class="round-card background-1">
			<v-card-title class="pa-3">
				<p class="pl-2 pl-xl-3">Esegui Rettifiche di Inventario</p>
				<v-spacer></v-spacer>
			</v-card-title>
			<v-divider></v-divider>

            <v-list three-line subheader class="background-2 pa-2">
                <v-subheader>Scarica modello per effettuare l'importazione delle rettifiche di magazzino</v-subheader>
                <v-list-item>
                    <v-list-item-action>
                        <v-btn class="mx-0" width="106" color="info" @click.native="downloadTemplate()">modello</v-btn>
                    </v-list-item-action>
                    <v-list-item-content></v-list-item-content>
                </v-list-item>
            </v-list>
            <v-subheader class="background-2">
                Carica il modello compilato con le rettifiche di inventario
            </v-subheader>            
            <v-container fluid class="background-2">
				<fields-generator
					v-if="loaded"
					:fieldsset.sync="fieldsset"
					:model.sync="model"
					ref="fieldsgenerator"
				></fields-generator>
			</v-container>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="info" @click.native="$emit('close')">Annulla
				</v-btn>
				<v-btn text color="primary" @click.native="generateInventory()" :loading="loading">Procedi
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
    import FormsMixin from '@/mixins/FormsMixin'

    export default {
        name: 'inventory-dialog',
        mixins: [FormsMixin],
        props: {
            modelDef: String,
            open: Boolean,
        },
        data() {
            return {
                model: {'date': moment().format('YYYY-MM-DD')},
                loading: false,
                fieldsset: {},
                loaded: false,
                firstTime: true,
            }
        },

        watch: {
            open: {
                handler() {
                    if(this.open == true && this.firstTime == true) {
                        this.axios.get('info-inventory-movements').then(response => {
                            // get body data
                            this.fieldsset = response.data.fields
                            this.loaded = true
                            this.firstTime = false

                        }, response => {
                            // error callback
                            this.loading = false
                        })
                    }
                }
            }
        },

        methods: {

            downloadTemplate() {
                this.$eventBusUtility.openFile(this.$store, '/inventory-downloadcsv/', 'inventario.csv')
            },

            generateInventory() {

                this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
                    if (!result) {
                        return this.handleValidationErrorAdvanced()
                    }			

                    this.loading = true
                    var formData = new FormData()
                    formData.append('file', this.model.file)
                    for (var key in this.model) {
                        if (this.model.hasOwnProperty(key)) {
                            formData.append(key, this.model[key])
                        }
                    }

                    this.axios.post('inventory-uploadcsv/',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                                'Accept': 'application/json'
                            }
                        }).then(response => {
                            // get body data
                            let data = response.data
                            let snackmessage = ''
                            let snackcolor = ''
                            if(data.status == 'success'){
                                snackmessage = 'Generazione Rettifiche Inventario avviata'
                                snackcolor = 'success'
                            } else{
                                snackmessage = data.message
                                snackcolor = 'warning'
                            }
                            this.$store.commit('setSnackbar', {timeout: 6000, text: snackmessage, value: true, color: snackcolor})
                            this.model = {'date': moment().format('YYYY-MM-DD')}
                            this.loading = false
                            this.$emit('close')
                            
                    }, response => {
                        // error callback
                        this.loading = false
                    })
                }).catch(() => {

                })				
            },
        },

    }
</script>

